import useCartAlerts from '@app/hooks/useCartAlerts';

import Alerts from '../../components/Alerts';

const CartAlerts = () => {
  const { alerts } = useCartAlerts();

  return <Alerts alerts={alerts} />;
};

export default CartAlerts;
